import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsEarlyAccessFeaturesRoute: InvariantJiraRoute = {
	name: 'polaris-settings-early-access-features',
	path: '/jira/settings/products/jira-product-discovery/early-access-features',
	exact: true,
};
